import React, { useEffect } from 'react';
import { useDashboardStore } from '../../store/dashboardStore';
import { UserProgress } from './components/UserProgress';
import { GameSection } from './components/games/GameSection';
import { MathsGames } from './components/games/MathsGames';
import { ReportTabs } from './components/reports/ReportTabs';
import { ReportContent } from './components/reports/ReportContent';

export const Dashboard: React.FC = () => {
  const { 
    studentFirstName,
    currentPoints,
    currentLevel,
    remainingPoints,
    animateCounter,
    animateRemainingCounter,
    animateProgress,
    selectedShape
  } = useDashboardStore();

  useEffect(() => {
    animateCounter();
    animateRemainingCounter();
    animateProgress();
  }, []);

  const shapeStyles = {
    circle: "rounded-full",
    triangle: "clip-path-triangle",
    square: "transform rotate-15"
  };

  const shapeColors = {
    circle: "#4558C8",
    triangle: "#DFF37D",
    square: "#EE5E37"
  };

  return (
    <main className="min-h-screen bg-white px-10 pt-8 pb-12 max-md:px-8 max-md:pt-6 max-sm:px-4 max-sm:pt-4">
      <div className="absolute top-8 right-10">
        <div 
          className={`w-[211px] h-[211px] ${shapeStyles[selectedShape]} bg-white`}
          style={{ backgroundColor: shapeColors[selectedShape] }}
        />
      </div>
      
      <div className="space-y-8">
        <UserProgress 
          userName={studentFirstName}
          points={currentPoints}
          level={currentLevel}
          pointsToNextLevel={remainingPoints}
          color={shapeColors[selectedShape]}
          selectedShape={selectedShape}
        />
        
        <ReportTabs />
        <ReportContent />
        
        <MathsGames />
        <GameSection />
      </div>
    </main>
  );
};